export default {"src":"/_next/static/media/ra-best-rate.2ef81ec7.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};